import { render, staticRenderFns } from "./RoomEmpty.vue?vue&type=template&id=061082b9&scoped=true"
import script from "./RoomEmpty.vue?vue&type=script&lang=js"
export * from "./RoomEmpty.vue?vue&type=script&lang=js"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061082b9",
  null
  
)

export default component.exports